<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Dự án: </strong>
          <span style="text-decoration: underline;">{{bomInfo.project}}</span>
          <strong> BOM: </strong>
          <span style="text-decoration: underline;">{{bomInfo.bom_name}}</span>
          <strong> Số lượng: </strong>
          <span style="text-decoration: underline;">{{bomInfo.quantity}}</span>

          <div class="card-header-actions d-flex">

            <CButton type="button" shape="pill" color="secondary"
                     class="ml-1 mr-1"
                     @click="resyncBOM">
              <CIcon name="cil-sync"/>
              Đồng bộ lại</CButton>

            <CButton type="button" shape="pill" color="secondary"
                     class="ml-1 mr-1"
                     @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>

          </div>
        </CCardHeader>

        <CCardBody class="p-1">
          <CTabs>
            <CTab title="Thiết kế">
              <CCard>
                <CCardHeader>
                  <strong>Thông tin thiết kế</strong>
                  <div class="card-header-actions">

                    <CSpinner
                      v-if="isUploading"
                      color="info"
                      style="width:1.2rem;height:1.2rem;"
                    />

                    <label
                      style="border: 1px solid #ced4da;border-radius: 0.375rem;padding: 0.375rem 0.75rem;"
                      for="fileInput"
                    >{{ fileName }}
                    </label>
                    <input type="file"
                           id="fileInput"
                           style="display: none;"
                           @change="onFileChange">

                    <CButton shape="pill" color="info"
                             class="ml-2"
                             @click="handleSubmit"
                             :disabled="isUploading"
                    >
                      <CIcon name="cil-cloud-upload"/>
                      {{ isUploading ? "Đang tải..." : "Tải lên" }}
                    </CButton>
                  </div>
                </CCardHeader>
                <CCardBody>
                  <CDataTable
                    :fields="headerDesign"
                    :items="records"
                  >

                    <template #no-items-view>
                      <div class="view-no-item">
                        Danh sách trống!
                      </div>
                    </template>
                    <template #stt="{item, index}">
                      <td class="py-2">
                        {{index+1}}
                      </td>
                    </template>
                    <template #actions="{item, index}">
                      <td>
                        <CDropdown
                          size="lg"
                          :caret="false"
                          placement="bottom-end">
                          <template #toggler>
                            <CButton variant="ghost">
                              <CIcon name="cil-list" size="lg"/>
                            </CButton>
                          </template>

                          <CDropdownItem @click="removeFromBOM(item, index)">
                            <CIcon name="cil-x" class="mr-2"/>Xóa khỏi BOM</CDropdownItem>
                        </CDropdown>
                      </td>
                    </template>
                  </CDataTable>
                </CCardBody>
              </CCard>
            </CTab>
            <CTab title="Rà soát kho">
              <CCard>
                <CCardHeader>
                  <strong>Rà soát kho và cập nhật số lượng linh kiện</strong>
                  <div class="card-header-actions">

                    <CButton type="button" shape="pill" color="info"
                             @click="updateBom"
                             class="mr-1"><CIcon name="cil-save"/>
                      Lưu rà soát
                    </CButton>
                  </div>
                </CCardHeader>
                <CCardBody>
                  <CDataTable
                    :fields="headerCheckRepo"
                    :items="records"
                  >

                    <template #no-items-view>
                      <div class="view-no-item">
                        Danh sách trống!
                      </div>
                    </template>
                    <template #stt="{item, index}">
                      <td class="py-2">
                        {{index+1}}
                      </td>
                    </template>

                    <template #location_repo="{item, index}">
                      <td class="py-2">
                        <div class="action-column">
                          <input
                            min="0"
                            class="qty-input" style="width: 12rem;"
                            v-model="item.location_repo"
                          />
                        </div>
                      </td>
                    </template>

                    <template #quan_found="{item, index}">
                      <td class="py-2">
                        <div class="action-column">
                          <input
                            type="number"
                            min="0"
                            :max="item.quan_available"
                            class="qty-input"
                            v-model.number="item.quan_found"
                          />
                        </div>
                      </td>
                    </template>

                    <template #note="{item, index}">
                      <td class="py-2">
                        <div class="action-column">
                          <input
                            min="0"
                            class="qty-input" style="width: 12rem;"
                            v-model="item.note"
                          />
                        </div>
                      </td>
                    </template>

                  </CDataTable>
                </CCardBody>
              </CCard>
            </CTab>
            <CTab title="Danh mục mua">
              <CCard>
                <CCardHeader>
                  <strong>Danh mục mua</strong>
                  <div class="card-header-actions">

                    <CButton type="button" shape="pill" color="info"
                             @click="updateBom"
                             class="mr-1"><CIcon name="cil-save"/>
                      Lưu danh mục mua
                    </CButton>

                    <CButton type="button" shape="pill" color="info"
                             @click="exportBill"
                             class="mr-1"><CIcon name="cil-save"/>
                      Xuất tệp danh mục mua
                    </CButton>
                  </div>
                </CCardHeader>
                <CCardBody>
                  <CDataTable
                    :fields="headerBuyBill"
                    :items="records"
                  >

                    <template #no-items-view>
                      <div class="view-no-item">
                        Danh sách trống!
                      </div>
                    </template>
                    <template #stt="{item, index}">
                      <td class="py-2">
                        {{index+1}}
                      </td>
                    </template>

                    <template #quan_buy="{item, index}">
                      <td class="py-2">
                        <div class="action-column">
                          <input
                            type="number"
                            min="0"
                            class="qty-input"
                            v-model.number="item.quan_buy"
                          />
                        </div>
                      </td>
                    </template>

                    <template #part_buy="{item, index}">
                      <td class="py-2">
                        <div class="action-column">
                          <input
                            min="0"
                            class="qty-input" style="width: 12rem;"
                            v-model="item.part_buy"
                          />
                        </div>
                      </td>
                    </template>

                    <template #quan_miss="{item}">
                      <td>
                        <CBadge :color="getBadge(item.quan_miss)">
                          {{item.quan_miss}}
                        </CBadge>
                      </td>
                    </template>

                  </CDataTable>
                </CCardBody>
              </CCard>
            </CTab>
            <CTab title="Tổng hợp">
              <CCard>
                <CCardHeader>
                  <strong>Tổng hợp thông tin sau xử lý</strong>
                  <div class="card-header-actions">

                    <CButton type="button" shape="pill" color="info"
                             @click="exportBOM"
                             class="mr-1"><CIcon name="cil-save"/>
                      Xuất tệp BOM
                    </CButton>
                  </div>
                </CCardHeader>
                <CCardBody>
                  <CDataTable
                    :fields="headerBom"
                    :items="records"
                  >

                    <template #no-items-view>
                      <div class="view-no-item">
                        Danh sách trống!
                      </div>
                    </template>
                    <template #stt="{item, index}">
                      <td class="py-2">
                        {{index+1}}
                      </td>
                    </template>

                    <template #quan_miss="{item}">
                      <td>
                        <CBadge :color="getBadge(item.quan_miss)">
                          {{item.quan_miss}}
                        </CBadge>
                      </td>
                    </template>


                  </CDataTable>
                </CCardBody>
              </CCard>
            </CTab>
            <CTab title="Cập nhật">
              <CCard>
                <CCardBody>
                  <CInput label="Tên BOM:" v-model="bomInfo.bom_name" :addLabelClasses="'text-right'"
                          horizontal/>
                  <CInput label="Số lượng:" v-model.number="bomInfo.quantity" :addLabelClasses="'text-right'"
                          horizontal/>
                  <div class="card-header-actions">

                    <CButton type="button" shape="pill" color="info"
                             @click="updateBomInfo"
                             class="mr-1"><CIcon name="cil-save"/>
                      Cập nhật
                    </CButton>
                  </div>
                </CCardBody>
              </CCard>
            </CTab>
          </CTabs>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>

</template>

<script>
export default {
  data () {
    return {
      bomName: '',
      headerBom: [
        { key: 'stt', label: 'STT'},
        { key: 'quan_per_board', label: 'SL / mạch'},
        { key: 'location_board', label: 'Vị trí / mạch'},
        { key: 'mfr_part', label: 'Mã'},
        { key: 'ees_code', label: 'Code'},
        { key: 'description', label: 'Mô tả'},
        { key: 'value', label: 'Giá trị'},
        { key: 'footpin', label: 'FP'},
        { key: 'quan_require', label: 'SL định mức'},
        { key: 'quan_stock', label: 'SL tồn'},
        { key: 'location_repo', label: 'Vị trí / kho'},
        { key: 'quan_available', label: 'SL khả dụng'},
        { key: 'quan_found', label: 'SL tìm thấy'},
        { key: 'quan_miss', label: 'SL cần mua'},
        { key: 'quan_buy', label: 'SL đặt mua'},
        { key: 'part_buy', label: 'Mã đặt mua'},
        { key: 'note', label: 'Ghi chú'},
      ],
      headerDesign: [
        { key: 'stt', label: 'STT'},
        { key: 'quan_per_board', label: 'SL / mạch'},
        { key: 'location_board', label: 'Vị trí / mạch'},
        { key: 'mfr_part', label: 'Mã'},
        { key: 'ees_code', label: 'Code'},
        { key: 'description', label: 'Mô tả'},
        { key: 'value', label: 'Giá trị'},
        { key: 'footpin', label: 'FP'},
        { key: 'note', label: 'Ghi chú'},
        { key: 'actions', label: 'Thao tác'},
      ],
      headerCheckRepo: [
        { key: 'stt', label: 'STT'},
        { key: 'ees_code', label: 'Code'},
        { key: 'mfr_part', label: 'Mã'},
        { key: 'description', label: 'Mô tả'},
        { key: 'value', label: 'Giá trị'},
        { key: 'footpin', label: 'FP'},
        { key: 'quan_require', label: 'SL định mức'},
        { key: 'quan_stock', label: 'SL tồn'},
        { key: 'quan_available', label: 'SL khả dụng'},
        { key: 'quan_found', label: 'SL tìm thấy'},
        { key: 'location_repo', label: 'Vị trí / kho'},
        { key: 'note', label: 'Ghi chú'},
      ],
      headerBuyBill: [
        { key: 'stt', label: 'STT'},
        { key: 'mfr_part', label: 'Mã'},
        { key: 'description', label: 'Mô tả'},
        { key: 'value', label: 'Giá trị'},
        { key: 'footpin', label: 'FP'},
        { key: 'quan_require', label: 'SL định mức'},
        { key: 'quan_available', label: 'SL khả dụng'},
        { key: 'quan_found', label: 'SL tìm thấy'},
        { key: 'quan_miss', label: 'SL cần mua'},
        { key: 'quan_buy', label: 'SL đặt mua'},
        { key: 'part_buy', label: 'Mã đặt mua'},
        { key: 'note', label: 'Ghi chú'},
      ],
      records: [],
      isUploading: false,
      fileName: 'Nhập BOM nguyên lý', // for purge BOM file upload
      selectedFile: null,
      bomInfo: {
        id: 0,
        project: 0,
        bom_name: '',
        quantity: 0,
      },
      action: {
        action: '',
      }
    }
  },
  created() {
    if (this.$route.query) {
      this.bomInfo = this.$route.query
    }
    // console.log(this.bomInfo);
    if(this.bomInfo.bom_name !== ''){
      this.getBomWithName(this.bomInfo.bom_name)
    }
  },
  computed: {

  },
  methods: {
    getBomWithName(bom_name) {
      this.$request.get(`/api/project/bom/${bom_name}`).
      then((res) => {
        // console.log(res.data);
        if(res.data.status === 'success') {
          this.records=res.data.bom;
        }
      })
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.fileName = this.selectedFile.name;
        // console.log('selected file name:', this.fileName)
      } else {
        // console.log('no file selected');
        this.fileName = 'Nhập BOM nguyên lý'
      }
    },
    handleSubmit() {
      if (!this.selectedFile) {
        this.$swal.fire({
          icon: "error",
          title: "Tải lên",
          text: "Vui lòng chọn tệp trước"
        });
        return;
      }

      // Create FormData instance to hold the file
      this.isUploading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("bom_name", this.bomInfo.bom_name)
      formData.append("project", this.bomInfo.project)
      formData.append("quantity", this.bomInfo.quantity)
      // Send file using Axios
      this.$request.post(`/api/project/bom/import`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
          if (res.data.status === 'success') {
            // console.log(res.data.status)
            this.getBomWithName(this.bomInfo.bom_name)
            this.$swal.fire({
              icon: "success",
              title: "Tải lên tệp",
              text: "Tệp: " + this.fileName + " đã tải lên thành công!",
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Tải lên tệp",
              html: "Tệp: " + this.fileName + " tải lên lỗi: " + res.data.status,
            });
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Tải lên tệp",
            html: "Tệp: " + this.fileName + " tải lên lỗi: " + error,
          });
        }).finally(()=>{
          this.isUploading = false;
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    updateBomInfo() {
      this.bomInfo.id = Number(this.bomInfo.id)
      this.$request.post(`/api/project/bom/updateinfo`, this.bomInfo).then((res) => {
        // console.log(res.data)
        if (res.data.status === 'success') {
          this.$swal.fire({
            icon: "success",
            title: "Cập nhật thông tin BOM",
            text: "Cập nhật thành công!",
          });
          this.getBomWithName(this.bomInfo.bom_name)
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Cập nhật thông tin BOM",
            html: "Lỗi: " + res.data.status,
          });
        }
      })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Cập nhật thông tin BOM",
            html: "Lỗi: " + error,
          });
        }).finally(()=>{
      });
    },
    removeFromBOM(item, index) {
      // console.log("Deleting item:", item.mfr_part, item.bom_name);
      this.$swal.fire({
        title: "Xóa danh mục khỏi BOM?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.delete(`/api/project/bom/delete/${item.id}`).
          then(res => {
            if(res.data.status === 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Xóa danh mục khỏi BOM",
                html: "Xóa danh mục khỏi BOM thành công" ,
              });
              this.getBomWithName(this.bomInfo.bom_name)
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xóa danh mục khỏi BOM",
                html: "Xóa danh mục khỏi BOM lỗi: " + res.data.status,
              });
            }
          })
        }
      });
    },
    getBadge (value) {
      if (value === 0) {
        return 'success'
      } else {
        return 'danger'
      }
    },
    updateBom() {
      if (this.records.length > 0) {
        // console.log(this.records);
        this.$request.post(`/api/project/bom/update`,
          {
            bom_name: this.bomInfo.bom_name,
            bom: this.records,
          }).then(res => {
          if (res.data.status === 'success') {
            this.$swal.fire({
              icon: "success",
              title: "Cập nhật BOM",
              text: "Cập nhật BOM thành công!",
            });
            this.getBomWithName(this.bomInfo.bom_name)
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Cập nhật BOM",
              html: "Cập nhật BOM lỗi: " + res.data.status,
            });
          }
        }).catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Cập nhật BOM",
            html: "Cập nhật BOM lỗi: " + error,
          });
        });
      }
    },
    exportBOM() {
      this.exportFile('bom')
    },
    exportBill() {
      this.exportFile('bill')
    },
    exportFile(action) {
      // console.log('export:', action);
      this.action.action = action;
      this.$request.post(`/api/project/bom/export/${this.bomInfo.bom_name}`, this.action).then(res => {
        if(res.data.status === 'success') {
          const fileName = res.data.filename;
          this.triggerDownload(fileName)
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Xuất tệp ",
            html: "Xuất tệp lỗi: " + res.data.status,
          })
        }
      })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Xuất tệp",
            html: "Xuất tệp lỗi: " + error,
          })
        });
    },
    triggerDownload(fileName) {
      this.$request.get(`/api/project/bom/download/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    resyncBOM() {
      this.$request.get(`/api/project/bomsync/${this.bomInfo.bom_name}`).
      then((res) => {
        // console.log(res.data);
        if (res.data.status === 'success') {
          this.$swal.fire({
            icon: "success",
            title: "Đồng bộ lại BOM",
            text: "Đồng bộ lại BOM thành công!",
          });
          this.records = res.data.bom;
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Đồng bộ lại BOM",
            html: "Đồng bộ lại BOM lỗi: " + res.data.status,
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.view-no-item {
  color: #888;
  text-align: center;
  padding: 10px;
  font-style: italic;
}


.qty-input {
  width: 80px; /* Max width for 4 characters */
  text-align: center;
  padding: 5px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.qty-input:focus {
  outline: none;
  border-color: #007bff;
}
</style>
